"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _bodyColumn = _interopRequireWildcard(require("../columns/body-column"));
var _descriptionDrawer = _interopRequireDefault(require("../common/description-drawer"));
var _chartCommon = require("../common/chart-common");
var _merchButton = require("@site/pattern-library-core/merch-button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const RowWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RowWrapper",
  class: "pl-r1y2fr1q",
  vars: {
    "r1y2fr1q-0": [({
      col = 2
    }) => `20vw repeat(${col}, 1fr)`],
    "r1y2fr1q-1": [({
      hasDescription
    }) => hasDescription ? 'pointer' : 'initial'],
    "r1y2fr1q-4": [({
      hasDescription
    }) => hasDescription ? `${_intents.default.ux.navigateHovered.foregroundColor}` : 'initial']
  }
});
const Column = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Column",
  class: "pl-cifh4si"
});
const DescriptionRow = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DescriptionRow",
  class: "pl-dj6sp9e",
  vars: {
    "dj6sp9e-0": [({
      col = 2
    }) => `20vw repeat(${col}, 1fr)`]
  }
});

/**
 * BodyRow Component.
 *
 * @param {Object} props React props
 * @param {Array} props.items Array of body columns
 * @param {String} props.rowGroupTitle Row group name
 * @param {String} props.featuredColumnText Featured column name
 * @param {String} props.descriptionText Body row descriptionText text
 * @param {Array} props.ctas Below rowGroupTitle ctas
 * @returns {React.ReactElement} BodyRow Component
 * @public
 */

function BodyRow({
  items,
  rowGroupTitle,
  featuredColumnText,
  descriptionText,
  ctas
}) {
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const [height, setHeight] = (0, _react.useState)('0px');
  const ref = (0, _react.useRef)(null);
  function toggleDescription(event) {
    if (event.target.tagName.toLowerCase() === 'a') {
      return;
    }
    if (event.type === 'click' || event.type === 'keypress' && event.key === 'Enter') {
      const newExpandedState = !expanded;
      setExpanded(newExpandedState);
      setHeight(newExpandedState ? `${ref.current.scrollHeight}px` : '0px');
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, rowGroupTitle && /*#__PURE__*/_react.default.createElement(_chartCommon.CategoryRow, {
    rowGroupTitle: rowGroupTitle,
    items: items,
    ctas: ctas
  }), /*#__PURE__*/_react.default.createElement(RowWrapper, {
    "data-cy": "table-row",
    role: "row",
    tabIndex: "0",
    col: items?.length,
    onClick: descriptionText ? toggleDescription : null,
    onKeyPress: e => descriptionText ? toggleDescription(e) : null,
    hasDescription: !!descriptionText
  }, /*#__PURE__*/_react.default.createElement(_bodyColumn.FeaturedColumn, {
    text: featuredColumnText,
    expanded: expanded,
    hasDescription: !!descriptionText
  }), items?.slice(0, 4).map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(Column, {
      key: idx,
      role: "cell"
    }, /*#__PURE__*/_react.default.createElement(_bodyColumn.default, item));
  })), descriptionText && /*#__PURE__*/_react.default.createElement(DescriptionRow, {
    role: "row",
    col: items?.length
  }, /*#__PURE__*/_react.default.createElement(_descriptionDrawer.default, {
    forwardedRef: ref,
    style: {
      maxHeight: `${height}`,
      opacity: `${expanded ? 1 : 0}`
    },
    descriptionText: descriptionText
  }), items?.slice(0, 4).map((item, i) => {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      key: i,
      role: "cell",
      "aria-hidden": true
    }, item));
  })));
}
var _default = exports.default = BodyRow;
BodyRow.propTypes = {
  items: _propTypes.default.array,
  rowGroupTitle: _propTypes.default.string,
  featuredColumnText: _propTypes.default.string,
  descriptionText: _propTypes.default.string,
  ctas: _propTypes.default.arrayOf(_propTypes.default.shape(_merchButton.NSMerchButton.propTypes))
};